<script>
  import { afterUpdate, createEventDispatcher } from "svelte"
  import { loadTooltip } from "../../../../Script/loadTooltip"
  import ConfirmationModal from "../../../Publish/BulkUpload/Shared/confirmationModal.svelte"
  import { copyToClipboard } from "../../../Publish/SinglePublish/script"
  import notify from "../../../../Script/notify"
  const dispatch = createEventDispatcher()

  export let json

  let showConfirmationModal = false

  let showReleaseConfirmationModal = false

  let copiedInfo = {
    close() {},
  }

  const borderMappings = {
    SIGNED: "border-lime-500 dark:hover:border-lime-500",
    COMPLETED: "border-green-500 dark:hover:border-green-500",
    APPROVED: "border-blue-500 dark:hover:border-blue-500",
    PENDING: "border-yellow-500 dark:hover:border-yellow-500",
    REJECTED: "border-red-500 dark:hover:border-red-500",
  }

  afterUpdate(() => {
    loadTooltip()
    window.addEventListener("resize", loadTooltip)
  })
</script>

{#if showConfirmationModal}
  <ConfirmationModal
    title="Confirmation for Publishing"
    content="I have thoroughly reviewed the signed document and am prepared to proceed to process the document for publishing."
    on:click={() => {
      showConfirmationModal = false
    }}
    on:confirm={() => {
      showConfirmationModal = false
      dispatch("confirm", {
        documentID: json.documentID,
        docketID: json.id,
      })
    }}
  />
{/if}

{#if showReleaseConfirmationModal}
  <ConfirmationModal
    title="Confirmation for Releasing Docket"
    content="Please note that once the docket is released, you will no longer be able to view it. Additionally, any linked documents will also be released."
    on:click={() => {
      showReleaseConfirmationModal = false
    }}
    on:confirm={() => {
      showReleaseConfirmationModal = false
      console.log({ json })
      dispatch("release", {
        documentID: json.documentID,
        docketID: json.id,
      })
    }}
  />
{/if}

<div class="{borderMappings[json.status]} relative mx-auto mt-3 flex h-full w-full flex-col gap-3 rounded-r-md border-l-8 bg-white px-6 py-3 hover:shadow-md dark:border-y-2 dark:border-r-2 dark:border-y-transparent dark:border-r-transparent dark:bg-lightgray">
  <div class="flex w-full items-center justify-between gap-6">
    <div class="truncate">
      <!-- <div class="flex select-none flex-col truncate sm:flex-row sm:items-center sm:gap-3">
        <span class="truncate font-semibold text-gray-800 dark:text-gray-200">{json.name || json.id}</span>
      </div> -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <h2
        on:click={async () => {
          try {
            copiedInfo.close()
            await copyToClipboard(json.uuid)
            copiedInfo = notify.info("Docket UUID copied to clipboard")
          } catch (error) {
            const info = "PAGE: Docket List\nEVENT: While copying Docket UUID"
            copiedInfo = notify.danger(error, info)
          }
        }}
        title={json.uuid}
        class="cursor-pointer select-none truncate text-sm font-bold text-gray-d00 dark:text-white/70 md:text-lg"
      >
        {json.uuid}
      </h2>
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <h2
        on:click={async () => {
          try {
            copiedInfo.close()
            await copyToClipboard(json.name || json.id)
            copiedInfo = notify.info(`${json.name ? "Docket Name" : "Docket ID"} copied to clipboard`)
          } catch (error) {
            const info = `PAGE: Docket List\nEVENT: While copying ${json.name ? "Docket Name" : "Docket ID"}`
            copiedInfo = notify.danger(error, info)
          }
        }}
        class="cursor-pointer select-none truncate text-xs font-medium text-gray-500 md:text-sm"
      >
        <!-- {new Date(template.created).toString().slice(0, 24)} -->
        {json.name || json.id}
      </h2>
      <!-- <div title={json.name} class="w-full truncate text-xs font-semibold text-gray-800 dark:text-gray-200 sm:text-base">{json.name}</div> -->
      <p class="mt-2 select-none truncate text-xs font-normal text-gray-200 sm:text-base">
        <i class="fa-solid fa-calendar-days" />
        &nbsp;&nbsp;{new Date(json.created).toString().slice(0, 24)}
      </p>
    </div>

    <div class="flex select-none justify-end">
      {#if json.documentID && json.status == "SIGNED"}
        <button
          on:click={() => {
            showConfirmationModal = true
          }}
          name="tooltip"
          id="Proceed to Publish"
          tooltip-position="top"
          type="button"
          class="flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-orange-500 hover:bg-orange-500 hover:text-white active:bg-orange-600 active:text-white sm:px-5"
        >
          <i class="fa-solid fa-forward" />
          <span class="hidden lg:block">Proceed to Publish</span>
        </button>
      {/if}
      {#if json.status == "REJECTED"}
        <button
          on:click={() => {
            showReleaseConfirmationModal = true
          }}
          name="tooltip"
          id="Release Docket"
          tooltip-position="top"
          type="button"
          class="flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-red-500 hover:bg-red-500 hover:text-white active:bg-red-600 active:text-white sm:px-5"
        >
          <i class="fa-solid fa-trash-can" />
          <span class="hidden lg:block">Release Docket</span>
        </button>
      {/if}
      <a name="tooltip" id="View Docket" tooltip-position="top" href="#/signing/single/docket?id={json.id}&fromDocketList=true" class="flex items-center justify-center gap-2 whitespace-nowrap rounded-full px-3 py-2 text-sm font-medium text-sky-500 hover:bg-sky-500 hover:text-white active:bg-sky-600 active:text-white sm:px-5">
        <i class="fa-solid fa-eye" />
        <span class="hidden lg:block">View Docket</span>
      </a>
    </div>
  </div>
</div>
